/**
 * Integrytas Group - Common Security Module (CSM)
 * pickDefaultRow - resolve the default row of an org master.
 *
 * Precedence: an explicit is_default='Y' row always wins. When no row is
 * flagged AND exactly one active row exists, that sole row becomes the default
 * (so a single Company/Division/Office/Business Unit auto-associates to new
 * users without an admin having to set the flag). Two-plus unflagged rows -> no
 * default (the user picks).
 */
export function pickDefaultRow<T extends { is_default: 'Y' | 'N' }>(rows: T[]): T | undefined {
  return rows.find(r => r.is_default === 'Y') ?? (rows.length === 1 ? rows[0] : undefined);
}
